import { SelectorOptionModel } from '../pages/Builder/components/CharacterDescription/CharacterDescriptionInputs.model';

export enum HowDidYouFindUsType {
  Instagram = 'instagram',
  FacebookGroup = 'facebook_group',
  GoogleSearch = 'google_search',
  Email = 'email',
  Colleague = 'colleague',
  Conference = 'conference',
  Other = 'other',
}

export enum BookCostCoverageType {
  FamiliesChoose = 'families_choose',
  SchoolCovers = 'school_covers',
  EBooksOnly = 'ebooks_only',
}

export enum TeacherFirstUseType {
  AtHome = 'home',
  WithMyClass = 'class',
}

export enum ProgramTypeEnum {
  IndividualBooks = 'individual_books',
  ClassBook = 'class_book',
}

export interface TeacherTourPayload {
  show: boolean;
  step: number;
}

export interface FinalSurveyResponses {
  readiness: 'clear' | 'not_yet' | null;
  readinessComment?: string | null;
  confidence: 'confident' | 'not_yet' | null;
  confidenceComment?: string | null;
  storyChoice: 'yes' | 'no' | null;
  storyType?: string | null;
  customSupport: 'yes' | 'no' | null;
  writingApproach: 'full_story' | 'ai_assisted' | 'not_sure' | null;
}

export enum JobRoleType {
  Teacher = 'teacher',
  Librarian = 'librarian',
  Admin = 'admin',
  Counselor = 'counselor',
  Other = 'other',
}

export interface TeacherOnboardingModel {
  firstUseType?: TeacherFirstUseType;
  grades?: GradeType[];
  customGrade?: string;
  studentCount?: number;
  schoolName?: string;
  schoolId?: string;
  programType?: ProgramTypeEnum;
  startDate?: Date;
  startDateTime?: string;

  videoWatchTimeSeconds?: number;
  country?: string;
  state?: string;
  city?: string;
  mobileNumber?: string;
  jobRole?: JobRoleType;
  jobRoleOther?: string;
  howFoundUs?: HowDidYouFindUsType;
  howFoundUsOther?: string;
  referralCode?: string;
  bookCostCoverage?: BookCostCoverageType;
  completedAt?: Date | string;
  finalSurveyCompleted?: boolean;
  finalSurveySkipped?: boolean;
  finalSurveyResponses?: FinalSurveyResponses | null;
}

export enum GradeType {
  Kindergarten = 'kindergarte',
  Grade1 = 'grade1',
  Grade2 = 'grade2',
  Grade3 = 'grade3',
  Grade4 = 'grade4',
  Grade5 = 'grade5',
  Grade6 = 'grade6',
  Grade7 = 'grade7',
  Grade8 = 'grade8',
  Grade9 = 'grade9',
  Other = 'other',
}

// Grade options
export const gradeSelectOptions: SelectorOptionModel[] = [
  {
    title: 'Kindergarten (age 5-6)',
    value: GradeType.Kindergarten,
    color: 'rgb(169, 68, 66)',
  },
  {
    title: 'Grade 1 (age 6-7)',
    value: GradeType.Grade1,
    color: 'rgb(212, 136, 74)',
  },
  {
    title: 'Grade 2 (age 7-8)',
    value: GradeType.Grade2,
    color: 'rgb(194, 168, 18)',
  },
  {
    title: 'Grade 3 (age 8-9)',
    value: GradeType.Grade3,
    color: 'rgb(61, 163, 93)',
  },
  {
    title: 'Grade 4 (age 9-10)',
    value: GradeType.Grade4,
    color: 'rgb(74, 144, 226)',
  },
  {
    title: 'Grade 5 (age 10-11)',
    value: GradeType.Grade5,
    color: 'rgb(138, 91, 160)',
  },
  {
    title: 'Grade 6 (age 11-12)',
    value: GradeType.Grade6,
    color: 'rgb(186, 85, 211)',
  },
  {
    title: 'Grade 7 (age 12-13)',
    value: GradeType.Grade7,
    color: 'rgb(255, 105, 180)',
  },
  {
    title: 'Grade 8 (age 13-14)',
    value: GradeType.Grade8,
    color: 'rgb(255, 99, 71)',
  },
  {
    title: 'Grade 9 (age 14-15)',
    value: GradeType.Grade9,
    color: 'rgb(0, 191, 255)',
  },
  {
    title: 'Other',
    value: GradeType.Other,
    color: 'rgb(177, 60, 148)',
  },
];
